import React from 'react';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { theme } from './utils/theme';
import { useTawkTo } from './hooks/useTawkTo';
import { usePageMeta } from './hooks/usePageMeta';
import { useGoogleTagManager, GTM_NOSCRIPT_SRC } from './hooks/useGoogleTagManager';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { About } from './components/About';
import { Gallery } from './components/Gallery';
import { Experts } from './components/Experts';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Disclaimer } from './components/Disclaimer';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
export function App() {
  usePageMeta();
  useGoogleTagManager();
  useTawkTo();
  return <ChakraProvider theme={theme} data-id="element-0" data-mp="23ut9zyugts8o">
      <noscript data-id="element-1" data-mp="3ijxqiu0iq6lh">
        <iframe src={GTM_NOSCRIPT_SRC} height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} title="Google Tag Manager" data-id="element-2" data-mp="3ikh7o8icgqyg" />
      </noscript>
      <Box w="100%" minH="100vh" bg="cream.50" data-id="element-3" data-mp="3rbznujfaj6rj">
        <Header data-id="element-4" data-mp="3reccfffk0fdk" />
        <Box as="main" data-id="element-5" data-mp="5yi8qe3h5da">
          <Hero data-id="element-6" data-mp="67znpl2q47d" />
          <Services data-id="element-7" data-mp="4n4bxqxqh8g" />
          <WhyUs data-id="element-8" data-mp="56n1goet9nj" />
          <About data-id="element-9" data-mp="7svdij4jt6t" />
          <Gallery data-id="element-10" data-mp="2zld0746gb58w" />
          <Experts data-id="element-11" data-mp="2zlv7qwykd5w4" />
          <Testimonials data-id="element-12" data-mp="2zmemy5wtxg6g" />
          <Contact data-id="element-13" data-mp="2zn6biws0edn8" />
        </Box>
        <Footer data-id="element-14" data-mp="33mf6g4yschkd" />
        <Disclaimer data-id="element-15" data-mp="33lx0uhq8gqzs" />
        <FloatingCta data-id="element-16" data-mp="33n6zb810016y" />
      </Box>
    </ChakraProvider>;
}